var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNuvamaNotSelected = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0478516,
    width: 42,
    height: 42,
    rx: 14.6667,
    fill: "#DDE2EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9477 13.2471C29.9477 15.9707 27.7409 18.1779 25.0176 18.1779C22.2944 18.1779 20.0875 15.9707 20.0875 13.2471H16.0547C16.0547 18.1968 20.0687 22.2113 25.0176 22.2113C29.9666 22.2113 33.9806 18.1968 33.9806 13.2471H29.9477Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1266 28.7777C11.1266 26.0541 13.3335 23.8469 16.0567 23.8469C18.7799 23.8469 20.9868 26.0541 20.9868 28.7777H25.0197C25.0197 23.828 21.0057 19.8135 16.0567 19.8135C11.1077 19.8103 7.09375 23.8249 7.09375 28.7777H11.1266Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNuvamaNotSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nuvamaNotSelected.2f678a1aea82684a69ef550e116358d3.svg";